{
  "printedAt": "طُبع في {{at}}",
  "vatNumber": "الرقم الضريبي",
  "account": "الحساب",
  "amount": "المبلغ",
  "invalidRange": "تاريخ النهاية قبل تاريخ البداية.",
  "exportCsv": "تصدير CSV",
  "exportedCsv": "تم تصدير التقرير",
  "profitAndLoss": {
    "title": "الأرباح والخسائر",
    "comparison": "المقارنة",
    "compareWith": "المقارنة مع",
    "compareModes": {
      "off": "بلا مقارنة",
      "previous": "الفترة السابقة",
      "lastYear": "الفترة نفسها من السنة الماضية",
      "custom": "فترة مخصصة"
    },
    "compareFrom": "فترة المقارنة من",
    "compareTo": "فترة المقارنة إلى",
    "comparedWith": "مقارنةً بالفترة {{period}}",
    "current": "هذه الفترة",
    "compared": "فترة المقارنة",
    "difference": "الفرق",
    "revenue": "الإيرادات",
    "expenses": "المصروفات",
    "totalRevenue": "إجمالي الإيرادات",
    "totalExpenses": "إجمالي المصروفات",
    "netProfit": "صافي الربح",
    "netLoss": "صافي الخسارة",
    "noRevenue": "لا توجد إيرادات في هذه الفترة.",
    "noExpenses": "لا توجد مصروفات في هذه الفترة.",
    "empty": "لا توجد ترحيلات على حسابات الإيرادات أو المصروفات في هذه الفترة.",
    "emptyBody": "اختر فترة أخرى.",
    "hint": "المبالغ بالريال العماني. قيود إقفال نهاية السنة مستبعدة. اختر حسابًا لفتح دفتر الأستاذ الخاص به للفترة."
  },
  "balanceSheet": {
    "title": "الميزانية العمومية",
    "asOf": "كما في {{date}}",
    "asOfLabel": "التاريخ",
    "fiscalYearStart": "السنة المالية من {{date}}",
    "computed": "محسوب",
    "computedHint": "محسوب من حسابات الإيرادات والمصروفات، وليس حسابًا مستقلًا.",
    "balanced": "الأصول تساوي الخصوم وحقوق الملكية",
    "unbalanced": "غير متوازنة بمقدار {{amount}}",
    "assets": "الأصول",
    "liabilities": "الخصوم",
    "equity": "حقوق الملكية",
    "totalAssets": "إجمالي الأصول",
    "totalLiabilities": "إجمالي الخصوم",
    "totalEquity": "إجمالي حقوق الملكية",
    "totalLiabilitiesAndEquity": "إجمالي الخصوم وحقوق الملكية",
    "empty": "لا توجد ترحيلات حتى هذا التاريخ.",
    "emptyBody": "اختر تاريخًا لاحقًا.",
    "hint": "المبالغ بالريال العماني. أرباح السنة الحالية هي ربح السنة المالية حتى هذا التاريخ: اخترها لفتح قائمة الأرباح والخسائر. اختر حسابًا لفتح دفتر الأستاذ الخاص به."
  },
  "generalLedger": {
    "title": "دفتر الأستاذ العام",
    "account": "الحساب",
    "chooseAccount": "اختر حسابًا",
    "noChart": "يتطلب اختيار الحساب صلاحية عرض دليل الحسابات.",
    "openNamed": "كشف حساب: {{name}}",
    "hint": "المبالغ بالريال العماني. يُحتسب الرصيد على الطبيعة المعتادة للحساب، ويظهر الرصيد السالب بالأحمر. تُحتسب كل القيود بما فيها قيود إقفال نهاية السنة. تطبع الطباعة الصفحة المعروضة.",
    "party": {
      "label": "الطرف",
      "any": "كل الأطراف",
      "types": {
        "CUSTOMER": "عميل",
        "SUPPLIER": "مورد"
      },
      "all": {
        "CUSTOMER": "كل العملاء",
        "SUPPLIER": "كل الموردين"
      },
      "search": "ابحث بالاسم أو الرمز أو الجوال…",
      "none": "لا توجد نتائج.",
      "failed": "تعذّر البحث. حاول مرة أخرى.",
      "printed": "{{type}}: {{party}}"
    },
    "empty": {
      "title": "اختر حسابًا",
      "body": "اختر حساب ترحيل لعرض قيوده في الفترة مع الرصيد الجاري والمجاميع.",
      "noChart": "افتح دفتر أستاذ الحساب من قائمة الأرباح والخسائر أو الميزانية العمومية أو ميزان المراجعة. يتطلب اختيار حساب هنا صلاحية عرض دليل الحسابات."
    },
    "headerAccount": {
      "title": "هذا حساب رئيسي",
      "body": "الحساب الرئيسي يجمّع الحسابات الفرعية فقط وليست له قيود خاصة به. اختر حساب ترحيل.",
      "bodyNamed": "الحساب {{account}} يجمّع الحسابات الفرعية فقط وليست له قيود خاصة به. اختر حساب ترحيل تحته."
    },
    "columns": {
      "date": "التاريخ",
      "entry": "القيد",
      "description": "البيان",
      "party": "الطرف",
      "debit": "مدين",
      "credit": "دائن",
      "balance": {
        "DEBIT": "الرصيد (مدين)",
        "CREDIT": "الرصيد (دائن)"
      },
      "balanceLabel": "الرصيد"
    },
    "openingBalance": "الرصيد الافتتاحي",
    "broughtForward": "رصيد منقول",
    "carriedForward": "رصيد مرحّل إلى الصفحة التالية",
    "periodTotals": "مجاميع الفترة كاملة",
    "closingBalance": "الرصيد الختامي في {{date}}",
    "noLinesInPeriod": "لا توجد قيود في هذه الفترة.",
    "linesRange": "الأسطر {{from}}–{{to}} من {{total}}"
  },
  "vatReturn": {
    "title": "إقرار ضريبة القيمة المضافة",
    "bySupplier": {
      "title": "ضريبة المدخلات حسب المورد",
      "hint": "لا تُسترد ضريبة المدخلات إلا بفاتورة ضريبية تحمل الرقم الضريبي للمورد. المصروفات التي لا تذكر موردًا تظهر معًا.",
      "supplier": "المورد",
      "vatin": "الرقم الضريبي",
      "documents": "المستندات",
      "noSupplier": "مصروفات لا تذكر موردًا",
      "missing": "بلا رقم ضريبي",
      "flagged_zero": "لا سطور بلا رقم ضريبي.",
      "flagged_one": "سطر واحد بلا رقم ضريبي: راجع فواتيره الضريبية قبل الاسترداد.",
      "flagged_two": "سطران بلا رقم ضريبي: راجع فواتيرهما الضريبية قبل الاسترداد.",
      "flagged_few": "{{count}} سطور بلا رقم ضريبي: راجع فواتيرها الضريبية قبل الاسترداد.",
      "flagged_many": "{{count}} سطرًا بلا رقم ضريبي: راجع فواتيرها الضريبية قبل الاسترداد.",
      "flagged_other": "{{count}} سطر بلا رقم ضريبي: راجع فواتيرها الضريبية قبل الاسترداد.",
      "empty": "لا ضريبة مدخلات في هذه الفترة."
    },
    "category": "الفئة",
    "categories": {
      "STANDARD": "خاضعة للنسبة الأساسية",
      "ZERO": "خاضعة لنسبة الصفر",
      "EXEMPT": "معفاة",
      "OUT_OF_SCOPE": "خارج نطاق الضريبة"
    },
    "net": "المبلغ الصافي",
    "tax": "الضريبة",
    "total": "الإجمالي",
    "output": "ضريبة المخرجات (التوريدات)",
    "input": "ضريبة المدخلات (المشتريات)",
    "noSupplies": "لا توجد توريدات في هذه الفترة.",
    "noPurchases": "لا توجد مشتريات خاضعة للضريبة في هذه الفترة.",
    "summary": "صافي الضريبة",
    "outputTax": "ضريبة المخرجات",
    "lessInputTax": "ناقص ضريبة المدخلات",
    "inputTax": "ضريبة المدخلات",
    "netPayable": "صافي الضريبة المستحقة",
    "netRefundable": "صافي الضريبة المستردة",
    "reconciliation": "المطابقة مع دفتر الأستاذ",
    "line": "البند",
    "account": "حساب الضريبة",
    "perDocuments": "المستندات",
    "perLedger": "الدفتر",
    "difference": "الفرق",
    "notMapped": "غير مربوط بحساب",
    "setUpMapping": "اضبطه في ربط الحسابات",
    "mismatch": "يختلف عن المستندات",
    "agree": "المستندات ودفتر الأستاذ متطابقان",
    "differ": {
      "title": "المستندات ودفتر الأستاذ غير متطابقين",
      "body": "ما رحّلته المستندات إلى حسابات الضريبة لا يطابق المستندات نفسها، وغالبًا لأن حساب ضريبة رُبط من جديد بعد الترحيل أو لأن بيانات صُحّحت يدويًا. افتح دفتر أستاذ الحساب للعثور على هذه القيود قبل تقديم الإقرار.",
      "unmapped": "أحد أدوار الضريبة غير مربوط بحساب، لذا يظهر مبلغه في الدفتر صفرًا."
    },
    "hint": "المبالغ بالريال العماني. تاريخ الاستحقاق الضريبي هو تاريخ المستند، والمبالغ بنسبة كل مستند مُرحّل. تفتح الصفحة على الشهر الماضي: اختر فترة الإقرار أعلاه.",
    "manual": {
      "title": "حركات ضريبية أخرى",
      "body": "قيود يدوية على حسابات الضريبة في هذه الفترة: سداد الضريبة أو تسويتها، والتصحيحات، والأرصدة الافتتاحية. وهي ليست جزءًا من الفرق أعلاه، الذي يقارن ما رحّلته المستندات.",
      "output": "حساب ضريبة المخرجات",
      "input": "حساب ضريبة المدخلات",
      "net": "الصافي"
    }
  },
  "total": "الإجمالي",
  "asOf": "كما في {{date}}",
  "asOfLabel": "بتاريخ",
  "warehouse": "المستودع",
  "allWarehouses": "كل المستودعات",
  "clearSearch": "مسح البحث",
  "rowsRange": "الصفوف {{from}}–{{to}} من {{total}}",
  "printedWarehouse": "المستودع: {{warehouse}}",
  "movementsHint": "عرض حركات المخزون",
  "emptySearch": {
    "title": "لا توجد نتائج مطابقة لبحثك.",
    "body": "جرّب اسمًا أو رمزًا آخر، أو امسح البحث."
  },
  "issues": {
    "title": "راجع خيارات التقرير",
    "endBeforeStart": "تاريخ النهاية قبل تاريخ البداية.",
    "rangeTooLong": "لا يغطي التقرير أكثر من {{years}} سنوات. اختر فترة أقصر.",
    "fields": {
      "from": "تاريخ البداية",
      "to": "تاريخ النهاية",
      "asOf": "التاريخ",
      "groupBy": "التجميع",
      "warehouseId": "المستودع",
      "terminalId": "الصندوق",
      "userId": "الكاشير",
      "q": "البحث",
      "sort": "الترتيب",
      "page": "الصفحة",
      "pageSize": "عدد الصفوف في الصفحة"
    }
  },
  "productSearch": {
    "placeholder": "ابحث باسم المنتج أو رمز الصنف…",
    "label": "البحث في المنتجات"
  },
  "columns": {
    "code": "الرمز",
    "user": "المستخدم",
    "tillSales": "مبيعات نقاط البيع",
    "receipts": "المقبوضات",
    "refunds": "المبالغ المستردة",
    "receiptCount": "المقبوضات (العدد)",
    "refundCount": "المبالغ المستردة (العدد)",
    "tillSaleCount": "مبيعات نقاط البيع (العدد)",
    "customer": "العميل",
    "supplier": "المورد",
    "product": "المنتج",
    "invoices": "الفواتير",
    "creditNotes": "الإشعارات الدائنة",
    "invoiced": "المفوتر",
    "credited": "المردود بإشعارات دائنة",
    "netSales": "صافي المبيعات",
    "vat": "الضريبة",
    "totalWithVat": "الإجمالي شامل الضريبة",
    "quantitySold": "المباع",
    "quantityReturned": "المرتجع",
    "netQuantity": "صافي الكمية",
    "cost": "التكلفة",
    "grossProfit": "إجمالي الربح",
    "margin": "هامش الربح",
    "otherLines": "بنود غير مرتبطة بمنتج",
    "purchases": "فواتير الشراء",
    "returns": "المرتجعات",
    "purchased": "المشتريات",
    "returned": "المرتجع للموردين",
    "netPurchases": "صافي المشتريات",
    "quantityPurchased": "المشترى",
    "quantitySentBack": "المُعاد للمورد",
    "quantity": "الكمية",
    "averageCost": "متوسط التكلفة",
    "value": "القيمة",
    "onHand": "المتوفر",
    "reorderLevel": "حد إعادة الطلب",
    "shortfall": "النقص",
    "date": "التاريخ",
    "till": "الصندوق",
    "cashier": "الكاشير",
    "sales": "المبيعات",
    "voided": "المُبطَلة",
    "gross": "إجمالي المبيعات",
    "vatIncluded": "الضريبة المشمولة",
    "tillReturns": "المرتجعات",
    "returnsVat": "ضريبة المرتجعات",
    "net": "الصافي",
    "netBeforeVat": "الصافي قبل الضريبة",
    "tillDiscounts": "الخصومات",
    "cash": "نقدًا",
    "card": "بطاقة",
    "bankTransfer": "تحويل بنكي",
    "otherTender": "أخرى",
    "onAccount": "على الحساب",
    "cashRefunds": "استردادات نقدية",
    "cardRefunds": "استردادات بالبطاقة",
    "variance": "فرق النقد",
    "salesperson": "مندوب المبيعات",
    "netAfterReturns": "الصافي بعد المرتجعات",
    "collected": "المحصّل"
  },
  "hub": {
    "title": "التقارير",
    "subtitle": "كل التقارير المتاحة لك مصنّفة حسب المجال. كل تقرير قابل للطباعة، ويحفظ رابطه خيارات التصفية.",
    "sections": {
      "financial": "التقارير المالية",
      "sales": "المبيعات",
      "purchasing": "المشتريات",
      "inventory": "المخزون",
      "pos": "نقاط البيع",
      "work": "العمل",
      "projects": "المشاريع"
    },
    "hints": {
      "trialBalance": "الرصيد الافتتاحي والحركة والرصيد الختامي لكل حساب.",
      "profitAndLoss": "الإيرادات والمصروفات خلال فترة، مع إمكانية المقارنة بفترة أخرى.",
      "balanceSheet": "الأصول والخصوم وحقوق الملكية في تاريخ معيّن.",
      "cashFlow": "من أين جاء النقد وأين ذهب، حسب النشاط، من الرصيد الافتتاحي إلى الختامي.",
      "generalLedger": "كل القيود على حساب واحد مع الرصيد الجاري.",
      "vatReturn": "ضريبة المخرجات والمدخلات لفترة الإقرار، مطابقةً مع دفتر الأستاذ.",
      "salesByCustomer": "صافي المبيعات لكل عميل، الأعلى أولًا.",
      "salesByProduct": "الكمية وصافي المبيعات والتكلفة وإجمالي الربح لكل منتج.",
      "salesByPeriod": "مجاميع المبيعات شهريًا أو يوميًا.",
      "salesByUser": "المبيعات منسوبة إلى من أنشأ الفاتورة، مع مبيعات نقاط البيع والمقبوضات والمبالغ المستردة لكل مستخدم. لنسبتها إلى المندوب، انظر المبيعات حسب مندوب المبيعات.",
      "receivablesAging": "ما على كل عميل حسب مدة تأخره عن السداد.",
      "purchasesBySupplier": "صافي المشتريات من كل مورد، الأعلى أولًا.",
      "purchasesByProduct": "الكمية المشتراة وصافي المشتريات لكل منتج.",
      "payablesAging": "ما عليك لكل مورد حسب مدة التأخر عن السداد.",
      "stockValuation": "كمية كل منتج وقيمته بالتكلفة في تاريخ معيّن.",
      "lowStock": "المنتجات التي بلغت حد إعادة الطلب أو نزلت عنه، الأكبر نقصًا أولًا.",
      "posSummary": "إيرادات الصناديق لكل يوم وصندوق وكاشير، مع طرق الدفع وفروق النقد.",
      "taskReport": "العمل المفتوح والمتأخر والمعطّل، والإنجاز في الموعد حسب الفريق والشخص والعميل.",
      "projectProfitability": "قيمة العقد والمفوتر والتكلفة حتى الآن وهامش الربح لكل مشروع، مع المحصّل والمستحق.",
      "projectBudgetVsActual": "الموازنة والملتزم به والتكلفة الفعلية لكل مشروع وفئة تكلفة، في تاريخ محدد.",
      "projectUnbilledWork": "بنود الفوترة الجاهزة والتكاليف القابلة للفوترة التي لم تُفوتر بعد، لكل مشروع.",
      "projectUtilisation": "الساعات حسب الشخص: المعتمدة وبانتظار الاعتماد والقابلة للفوترة، مقارنةً بما تتوقعه نسب تخصيصهم.",
      "salesBySalesperson": "المبيعات منسوبة إلى مندوب كل فاتورة: ما بيع وما أُرجع وما حُصّل. لنسبتها إلى من أنشأ الفاتورة، انظر المبيعات والتحصيلات حسب المستخدم."
    }
  },
  "cashFlow": {
    "title": "التدفقات النقدية",
    "sections": {
      "operating": "الأنشطة التشغيلية",
      "investing": "الأنشطة الاستثمارية",
      "financing": "الأنشطة التمويلية"
    },
    "net": {
      "operating": "صافي النقد من الأنشطة التشغيلية",
      "investing": "صافي النقد من الأنشطة الاستثمارية",
      "financing": "صافي النقد من الأنشطة التمويلية"
    },
    "noMovement": "لم يتحرك نقد في هذه الأنشطة خلال الفترة.",
    "opening": "النقدية والبنوك في بداية {{date}}",
    "netChange": "صافي التغير في النقدية",
    "closing": "النقدية والبنوك في نهاية {{date}}",
    "empty": "لم يتحرك أي نقد في هذه الفترة، ولم يكن هناك رصيد نقدي في بدايتها.",
    "emptyBody": "يظهر النقد هنا بعد ترحيل المقبوضات أو المدفوعات أو المصروفات على حساب نقدي أو بنكي. اختر فترة أخرى.",
    "hint": "المبالغ بالريال العماني وبالطريقة المباشرة: الداخل موجب والخارج سالب. كل سطر هو الحساب المقابل لحركة النقد؛ اختره لفتح دفتر الأستاذ الخاص به للفترة. التحويلات بين حسابات النقدية والبنوك مستبعدة."
  },
  "salesByCustomer": {
    "title": "المبيعات حسب العميل",
    "searchPlaceholder": "ابحث باسم العميل أو رمزه…",
    "searchLabel": "البحث في العملاء",
    "empty": "لا توجد مبيعات في هذه الفترة.",
    "emptyBody": "لا تُحتسب إلا الفواتير والإشعارات المدينة والدائنة المرحّلة. اختر فترة أخرى.",
    "hint": "المبالغ بالريال العماني وقبل الضريبة ما لم يُذكر غير ذلك. صافي المبيعات هو المفوتر مطروحًا منه المردود. يشمل الإجمالي كل العملاء لا هذه الصفحة وحدها. اختر عميلًا لفتح كشف حسابه."
  },
  "salesByProduct": {
    "title": "المبيعات حسب المنتج",
    "empty": "لم يُبع أي منتج في هذه الفترة.",
    "emptyBody": "لا تُحتسب إلا الفواتير والإشعارات الدائنة المرحّلة. اختر فترة أخرى.",
    "hint": "المبالغ بالريال العماني وقبل الضريبة. إشعارات الإرجاع تعيد الكمية والتكلفة، أما الخصومات اللاحقة فتنقص صافي المبيعات فقط. هامش الربح هو إجمالي الربح نسبةً إلى صافي المبيعات. تشمل المجاميع كل المنتجات."
  },
  "salesByPeriod": {
    "title": "المبيعات حسب الفترة",
    "groupBy": "التجميع",
    "groupings": {
      "month": "الشهر",
      "day": "اليوم"
    },
    "by": {
      "month": "شهريًا",
      "day": "يوميًا"
    },
    "empty": "لا توجد مبيعات في هذه الفترة.",
    "emptyBody": "لا تُحتسب إلا الفواتير والإشعارات المدينة والدائنة المرحّلة. اختر فترة أخرى.",
    "hint": "المبالغ بالريال العماني وقبل الضريبة ما لم يُذكر غير ذلك. تُحتسب الإشعارات الدائنة بتاريخها. اختر فترة لعرض مبيعاتها حسب العميل."
  },
  "salesByUser": {
    "title": "المبيعات والتحصيلات حسب المستخدم",
    "noUser": "بلا مستخدم مسجّل",
    "empty": "لا توجد مبيعات أو تحصيلات في هذه الفترة.",
    "emptyBody": "لا تُحتسب إلا الفواتير والإشعارات الدائنة والمقبوضات والمبالغ المستردة المرحّلة. اختر فترة أخرى.",
    "hint": "المبالغ بالريال العماني وقبل الضريبة. تُنسب المبيعات إلى من أنشأ الفاتورة، والإشعار الدائن إلى بائع فاتورته. مبيعات نقاط البيع هي الجزء من صافي المبيعات المسجّل في ورديات المستخدم نفسه بعد خصم مرتجعاتها. تُنسب المقبوضات والمبالغ المستردة إلى من سجّلها. أما تقرير المبيعات حسب مندوب المبيعات فينسب كل فاتورة إلى مندوبها، فيختلف التقريران حين يكون المندوب شخصًا آخر، كبيع في نقطة البيع لعميل له مندوبه الخاص."
  },
  "purchasesBySupplier": {
    "title": "المشتريات حسب المورد",
    "searchPlaceholder": "ابحث باسم المورد أو رمزه…",
    "searchLabel": "البحث في الموردين",
    "empty": "لا توجد مشتريات في هذه الفترة.",
    "emptyBody": "لا تُحتسب إلا فواتير الشراء ومرتجعات الموردين المرحّلة. اختر فترة أخرى.",
    "hint": "المبالغ بالريال العماني وقبل الضريبة ما لم يُذكر غير ذلك. صافي المشتريات هو المشتريات مطروحًا منها المرتجع. يشمل الإجمالي كل الموردين لا هذه الصفحة وحدها. اختر موردًا لفتح كشف حسابه."
  },
  "purchasesByProduct": {
    "title": "المشتريات حسب المنتج",
    "empty": "لم يُشترَ أي منتج في هذه الفترة.",
    "emptyBody": "لا تُحتسب إلا فواتير الشراء ومرتجعات الموردين المرحّلة. اختر فترة أخرى.",
    "hint": "المبالغ بالريال العماني وقبل الضريبة. تُجمع البنود غير المرتبطة بمنتج (الخدمات والشحن) في سطر واحد. تشمل المجاميع كل المنتجات."
  },
  "stockValuation": {
    "title": "تقييم المخزون",
    "empty": "لا يوجد مخزون في هذا التاريخ.",
    "emptyBody": "تظهر البضاعة هنا بعد استلامها بفاتورة شراء مرحّلة أو إدخالها بتسوية مخزون. اختر تاريخًا لاحقًا أو مستودعًا آخر.",
    "hint": "القيمة بمتوسط التكلفة المرجّح في نهاية اليوم. عند اختيار كل المستودعات يساوي الإجمالي رصيد حساب المخزون في دفتر الأستاذ. اختر كمية لعرض حركتها."
  },
  "lowStock": {
    "title": "نواقص المخزون",
    "subtitle": "المتوفر حاليًا عند حد إعادة الطلب أو دونه",
    "groupBy": "العرض",
    "groupings": {
      "total": "كل المستودعات معًا",
      "warehouse": "كل مستودع على حدة"
    },
    "empty": "لا يوجد صنف بلغ حد إعادة الطلب.",
    "emptyBody": "حدّد حد إعادة الطلب للمنتج لتُنبَّه هنا قبل نفاده.",
    "hint": "القاعدة نفسها المستخدمة في تصفية «عند حد إعادة الطلب أو دونه» في أرصدة المخزون. الأكبر نقصًا أولًا. اختر كمية لعرض حركتها."
  },
  "posSummary": {
    "title": "ملخص مبيعات نقاط البيع",
    "allTills": "كل الصناديق",
    "allCashiers": "كل الكاشيرين",
    "onlyTill": "عرض هذا الصندوق فقط",
    "onlyCashier": "عرض هذا الكاشير فقط",
    "tillFilter": "الصندوق: {{till}}",
    "cashierFilter": "الكاشير: {{cashier}}",
    "printedTill": "الصندوق: {{till}}",
    "printedCashier": "الكاشير: {{cashier}}",
    "empty": "لا توجد مبيعات من نقاط البيع في هذه الفترة.",
    "emptyBody": "تظهر هنا المبيعات المكتملة والمرتجعات في نقاط البيع. اختر فترة أخرى.",
    "emptyFiltered": "لا شيء لهذا الصندوق أو الكاشير في الفترة. أزل التصفية أو اختر فترة أخرى.",
    "hint": "المبالغ بالريال العماني شاملة الضريبة ما لم يُذكر غير ذلك. المرتجعات هي كل إشعار دائن مرحّل على بيع من نقاط البيع، ومنها ما يُصدر من المكتب الخلفي، وهي ليست مبالغ مستردة من الدرج. الصافي قبل الضريبة والخصومات على أساس تقارير المبيعات. تُحتسب المبيعات بتاريخ فاتورتها، والمرتجعات بتاريخ إشعارها الدائن، وفروق النقد بيوم إغلاق الوردية. اختر صندوقًا أو كاشيرًا لتضييق التقرير."
  },
  "taskReport": {
    "title": "إنجاز المهام",
    "teamFilter": "الفريق",
    "allTeams": "كل الفرق",
    "oneCustomer": "عميل واحد",
    "allCustomers": "عرض كل العملاء",
    "printedTeam": "الفريق: {{team}}",
    "printedCustomer": "العميل: {{customer}}",
    "percent": "{{percent}}٪",
    "empty": "لا توجد مهام في هذا التقرير.",
    "emptyBody": "لا يوجد عمل مفتوح، ولم يستحق أو يُنجز شيء في هذه الفترة. اختر فترة أخرى أو أزل التصفية.",
    "clearFilters": "إزالة التصفية",
    "hint": "تشمل الأرقام المهام التي يمكنك رؤيتها. العمل المفتوح كما هو اليوم، والإنجاز عن الفترة المختارة. «في الموعد» يعني أنها أُنجزت في تاريخ الاستحقاق المتفق عليه أو قبله. اختر رقمًا أو اسمًا لفتح تلك المهام.",
    "snapshot": {
      "title": "العمل المفتوح الآن",
      "asOf": "حتى {{date}}",
      "open": "مفتوحة",
      "openDetail": "لم تُنجز ولم تُلغَ بعد",
      "overdue": "متأخرة",
      "overdueDetail": "تجاوزت تاريخ استحقاقها",
      "unassigned": "غير مسندة",
      "nobodyWaiting": "لا شيء ينتظر من يتولاه",
      "waitUnderADay": "أطول انتظار أقل من يوم",
      "longestWait_zero": "أطول انتظار {{n}} يوم",
      "longestWait_one": "أطول انتظار يوم واحد",
      "longestWait_two": "أطول انتظار يومان",
      "longestWait_few": "أطول انتظار {{n}} أيام",
      "longestWait_many": "أطول انتظار {{n}} يومًا",
      "longestWait_other": "أطول انتظار {{n}} يوم",
      "blocked": "معطّلة",
      "blockedDetail": "بانتظار شخص أو أمر ما",
      "inReview": "قيد المراجعة",
      "reviewTime": "المراجعات في الفترة: الوسيط {{hours}} ساعة",
      "noReviews": "لم يُبتّ في أي مراجعة خلال الفترة",
      "stale_zero": "دون تحديث منذ {{n}} يوم",
      "stale_one": "دون تحديث منذ يوم",
      "stale_two": "دون تحديث منذ يومين",
      "stale_few": "دون تحديث منذ {{n}} أيام",
      "stale_many": "دون تحديث منذ {{n}} يومًا",
      "stale_other": "دون تحديث منذ {{n}} يوم",
      "staleDetail": "مفتوحة دون أي تحديث يُذكر",
      "customerDue": "أعمال العملاء المستحقة خلال 7 أيام",
      "customerDueBy": "مفتوحة، تستحق حتى {{date}}",
      "figures": "أرقام العمل المفتوح"
    },
    "delivery": {
      "title": "الإنجاز في الفترة",
      "onTime": "في الموعد",
      "onTimeDetail_zero": "{{onTime}} من {{n}} مستحقة في الفترة",
      "onTimeDetail_one": "{{onTime}} من مهمة واحدة مستحقة في الفترة",
      "onTimeDetail_two": "{{onTime}} من مهمتين مستحقتين في الفترة",
      "onTimeDetail_few": "{{onTime}} من {{n}} مهام مستحقة في الفترة",
      "onTimeDetail_many": "{{onTime}} من {{n}} مهمة مستحقة في الفترة",
      "onTimeDetail_other": "{{onTime}} من {{n}} مهمة مستحقة في الفترة",
      "nothingDue": "لم يستحق شيء في الفترة",
      "completed": "المنجزة",
      "completedDetail": "أُنجزت في الفترة",
      "cycle": "مدة الإنجاز",
      "days_zero": "{{n}} يوم",
      "days_one": "يوم واحد",
      "days_two": "يومان",
      "days_few": "{{n}} أيام",
      "days_many": "{{n}} يومًا",
      "days_other": "{{n}} يوم",
      "cycleDetail": "الوسيط، من أول بدء حتى الإنجاز",
      "rework": "إعادة العمل",
      "reworkDetail": "أُنجزت بعد إرجاعها أو إعادة فتحها",
      "effort": "الوقت المستغرق",
      "hours": "{{hours}} ساعة",
      "effortDetail_zero": "مقابل {{estimate}} ساعة مقدّرة، {{n}} مهمة",
      "effortDetail_one": "مقابل {{estimate}} ساعة مقدّرة، مهمة واحدة",
      "effortDetail_two": "مقابل {{estimate}} ساعة مقدّرة، مهمتان",
      "effortDetail_few": "مقابل {{estimate}} ساعة مقدّرة، {{n}} مهام",
      "effortDetail_many": "مقابل {{estimate}} ساعة مقدّرة، {{n}} مهمة",
      "effortDetail_other": "مقابل {{estimate}} ساعة مقدّرة، {{n}} مهمة",
      "noEffort": "لا توجد مهمة منجزة لها تقدير ووقت مستغرق معًا",
      "lateLink": "المهام التي أُنجزت متأخرة في الفترة",
      "figures": "أرقام الإنجاز"
    },
    "columns": {
      "open": "مفتوحة",
      "overdue": "متأخرة",
      "unassigned": "غير مسندة",
      "blocked": "معطّلة",
      "inReview": "قيد المراجعة",
      "dueInPeriod": "مستحقة في الفترة",
      "onTime": "في الموعد",
      "completed": "منجزة"
    },
    "tables": {
      "team": {
        "title": "حسب الفريق",
        "column": "الفريق",
        "none": "بلا فريق",
        "empty": "لا يوجد عمل للفرق في هذا التقرير."
      },
      "person": {
        "title": "حسب الشخص",
        "column": "المسؤول",
        "none": "غير مسندة",
        "empty": "لا يوجد عمل مسند في هذا التقرير.",
        "note": "مرتبون أبجديًا لا حسب العدد: عدد المهام المنجزة لا يعبّر عن حجم العمل وراءها."
      },
      "customer": {
        "title": "حسب العميل",
        "column": "العميل",
        "empty": "لا يوجد عمل للعملاء في هذا التقرير."
      }
    },
    "leftOut": {
      "title": "ما لا تشمله هذه الأرقام",
      "parents_zero": "لا توجد مهام لها مهام فرعية.",
      "parents_one": "مهمة واحدة لها مهام فرعية: تُحتسب من خلال مهامها الفرعية، فلا يُحتسب العمل مرتين.",
      "parents_two": "مهمتان لهما مهام فرعية: تُحتسبان من خلال مهامهما الفرعية، فلا يُحتسب العمل مرتين.",
      "parents_few": "{{n}} مهام لها مهام فرعية: تُحتسب من خلال مهامها الفرعية، فلا يُحتسب العمل مرتين.",
      "parents_many": "{{n}} مهمة لها مهام فرعية: تُحتسب من خلال مهامها الفرعية، فلا يُحتسب العمل مرتين.",
      "parents_other": "{{n}} مهمة لها مهام فرعية: تُحتسب من خلال مهامها الفرعية، فلا يُحتسب العمل مرتين.",
      "noCommittedDate_zero": "لا توجد مهام منجزة بلا تاريخ استحقاق متفق عليه.",
      "noCommittedDate_one": "مهمة منجزة واحدة بلا تاريخ استحقاق متفق عليه، فهي خارج نسبة الإنجاز في الموعد.",
      "noCommittedDate_two": "مهمتان منجزتان بلا تاريخ استحقاق متفق عليه، فهما خارج نسبة الإنجاز في الموعد.",
      "noCommittedDate_few": "{{n}} مهام منجزة بلا تاريخ استحقاق متفق عليه، فهي خارج نسبة الإنجاز في الموعد.",
      "noCommittedDate_many": "{{n}} مهمة منجزة بلا تاريخ استحقاق متفق عليه، فهي خارج نسبة الإنجاز في الموعد.",
      "noCommittedDate_other": "{{n}} مهمة منجزة بلا تاريخ استحقاق متفق عليه، فهي خارج نسبة الإنجاز في الموعد.",
      "noEffort_zero": "لا توجد مهام منجزة ينقصها التقدير أو الوقت المستغرق.",
      "noEffort_one": "مهمة منجزة واحدة ينقصها التقدير أو الوقت المستغرق، فهي خارج رقم الوقت.",
      "noEffort_two": "مهمتان منجزتان ينقصهما التقدير أو الوقت المستغرق، فهما خارج رقم الوقت.",
      "noEffort_few": "{{n}} مهام منجزة ينقصها التقدير أو الوقت المستغرق، فهي خارج رقم الوقت.",
      "noEffort_many": "{{n}} مهمة منجزة ينقصها التقدير أو الوقت المستغرق، فهي خارج رقم الوقت.",
      "noEffort_other": "{{n}} مهمة منجزة ينقصها التقدير أو الوقت المستغرق، فهي خارج رقم الوقت.",
      "nothing": "لا توجد مهام لها مهام فرعية، ولكل مهمة منجزة تاريخ استحقاق متفق عليه وتقدير ووقت مستغرق.",
      "scope": "تُحتسب المهام التي يمكنك رؤيتها فقط. المهام الملغاة خارج أرقام الإنجاز."
    }
  },
  "projectReports": {
    "searchPlaceholder": "ابحث برمز المشروع أو اسمه…",
    "searchLabel": "البحث في المشاريع",
    "status": "حالة المشروع",
    "openStatuses": "المشاريع المفتوحة",
    "allStatuses": "الكل، بما فيها المغلقة",
    "export": "تصدير CSV",
    "exported": "صُدّر التقرير",
    "emptyBody": "تظهر فقط المشاريع التي يحق لك الاطلاع على أموالها. اختر حالة أخرى أو امسح عوامل التصفية.",
    "profitability": {
      "title": "ربحية المشاريع",
      "empty": "لا توجد مشاريع للعرض.",
      "hint": "المبالغ بالريال العماني. المفوتر والتكلفة قبل ضريبة القيمة المضافة، والمستحق شامل لها. هامش الربح هو المفوتر ناقص التكلفة حتى الآن. الإجماليات تشمل كل المشاريع لا هذه الصفحة فقط. الموازنة والمحصّل في ملف CSV. اختر مشروعًا لفتح موازنته وتكاليفه."
    },
    "budget": {
      "title": "موازنة المشاريع مقابل الفعلي",
      "empty": "لا توجد موازنات أو تكاليف للعرض.",
      "hint": "المبالغ بالريال العماني قبل ضريبة القيمة المضافة، كما في نهاية التاريخ. الملتزم به هو ما ستضيفه المشتريات المسودة المرتبطة بالمشروع. المتبقي هو الموازنة ناقص الفعلي والملتزم به. اختر فئة لفتح بنود تكاليفها.",
      "overOnly": "فقط ما بلغ حد التحذير أو تجاوزه",
      "noCategory": "بلا فئة"
    },
    "unbilled": {
      "title": "أعمال المشاريع غير المفوترة",
      "empty": "لا شيء بانتظار الفوترة.",
      "emptyBody": "تظهر بنود الفوترة هنا متى أصبحت جاهزة، والتكاليف القابلة للفوترة متى رُحّلت. تظهر فقط المشاريع التي يحق لك الاطلاع على أموالها.",
      "hint": "المبالغ بالريال العماني قبل ضريبة القيمة المضافة. «جاهز للفوترة» يجمع بنود خطة الفوترة الجاهزة، والتكاليف القابلة للفوترة هي تكاليف الوقت والمواد التي لم تُفوتر بعد. اختر مبلغًا لفتح تبويب الفوترة في المشروع."
    },
    "columns": {
      "project": "المشروع",
      "customer": "العميل",
      "status": "الحالة",
      "contract": "قيمة العقد",
      "budget": "الموازنة",
      "billed": "المفوتر",
      "cost": "التكلفة حتى الآن",
      "margin": "هامش الربح",
      "marginPct": "نسبة الهامش",
      "collected": "المحصّل",
      "outstanding": "المستحق",
      "category": "فئة التكلفة",
      "committed": "الملتزم به",
      "actual": "الفعلي",
      "remaining": "المتبقي",
      "use": "المستهلك",
      "readyItems": "البنود الجاهزة",
      "readyAmount": "جاهز للفوترة",
      "readySince": "جاهز منذ",
      "tm": "تكاليف قابلة للفوترة",
      "tmOldest": "أقدم تكلفة",
      "total": "إجمالي غير المفوتر",
      "forecastMarginPct": "هامش الربح المتوقع"
    },
    "notMeasured": "لم يُقس بعد"
  },
  "scopeRestricted": {
    "title": "هذا التقرير يشمل جميع المشتريات",
    "body": "صلاحيتك محصورة في جزء من المشتريات، لذا هذا التقرير غير متاح لك. استخدم قائمة المشتريات التي تعرض ما يمكنك رؤيته."
  },
  "salesScopeRestricted": {
    "title": "هذا التقرير يشمل جميع مستندات المبيعات",
    "body": "صلاحيتك محصورة في جزء من مستندات المبيعات، لذا هذا التقرير غير متاح لك. استخدم قوائم الفواتير والمقبوضات والإشعارات الدائنة التي تعرض ما يمكنك رؤيته."
  },
  "utilisation": {
    "title": "استخدام وقت الفريق",
    "hint": "الساعات المسجلة على المشاريع التي يمكنك رؤيتها، حسب الشخص وخلال الفترة. الساعات المتوقعة من نسب التخصيص: نسبة التخصيص × أيام العمل × ساعات اليوم. ونسبة الاستخدام هي الساعات المعتمدة وبانتظار الاعتماد مقارنةً بالمتوقعة، ونسبة الفوترة حصة ما يُفوتر منها. والوحدة التنظيمية هي الوحدة الأساسية لكل شخص. وتظهر التكلفة والقيمة القابلة للفوترة لمن لديه صلاحية رؤيتها فقط.",
    "columns": {
      "person": "الشخص",
      "expected": "المتوقع",
      "approved": "المعتمد",
      "submitted": "بانتظار الاعتماد",
      "billable": "قابل للفوترة",
      "nonBillable": "غير قابل للفوترة",
      "billablePct": "نسبة الفوترة",
      "utilisationPct": "نسبة الاستخدام",
      "cost": "التكلفة",
      "value": "القيمة القابلة للفوترة"
    },
    "filters": {
      "orgUnit": "الوحدة التنظيمية",
      "allUnits": "كل الوحدات",
      "project": "المشروع",
      "allProjects": "كل المشاريع",
      "oneProject": "المشروع المختار",
      "person": "الشخص",
      "everyone": "الجميع",
      "onePerson": "الشخص المختار",
      "clear": "كل المشاريع"
    },
    "projects_zero": "لا مشاريع",
    "projects_one": "مشروع واحد",
    "projects_two": "مشروعان",
    "projects_few": "{{n}} مشاريع",
    "projects_many": "{{n}} مشروعًا",
    "projects_other": "{{n}} مشروع",
    "empty": "لم يُسجَّل وقت في هذه الفترة.",
    "emptyBody": "لا يُحتسب إلا الوقت المسجل على المشاريع التي يمكنك رؤيتها. اختر فترة أخرى أو امسح عوامل التصفية.",
    "tooLong": "لا تتجاوز فترة تقرير استخدام وقت الفريق 366 يومًا. اختر فترة أقصر."
  },
  "salesBySalesperson": {
    "title": "المبيعات حسب مندوب المبيعات",
    "hint": "تُنسب كل فاتورة إلى مندوبها: فواتير كل مندوب ومرتجعاته ومجمل ربحه وما سدده العملاء منها. أما تقرير المبيعات والتحصيلات حسب المستخدم فينسبها إلى من أنشأ الفاتورة.",
    "none": "بلا مندوب",
    "empty": "لا مبيعات في هذه الفترة",
    "emptyBody": "اختر فترة أخرى."
  }
}
